// FE-52: gerçek i18next entegrasyonu. Önceki "dil seçimi" localStorage + tam sayfa reload
// yapıyordu ama hiçbir metni gerçekten çevirmiyordu. Şimdilik nav/başlık gibi her sayfada
// görünen çerçeve metinleri çevrildi (i18n/locales/*.json); sayfa içi Türkçe metinlerin
// tamamının t()'e taşınması ayrı, çok daha büyük bir iş — kapsam bilerek sınırlı tutuldu.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './locales/tr.json';
import en from './locales/en.json';

const stored = (() => {
  try { return localStorage.getItem('arvis_ui_language'); } catch { return null; }
})();

i18n.use(initReactI18next).init({
  resources: { tr: { translation: tr }, en: { translation: en } },
  lng: stored || 'tr',
  fallbackLng: 'tr',
  interpolation: { escapeValue: false },
});

export default i18n;
